// import React, { useState, useEffect, useRef } from "react";
// import { createPortal } from "react-dom";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   RiSearchLine,
//   RiCloseLine,
//   RiDeleteBinLine,
//   RiCheckLine,
//   RiErrorWarningLine,
//   RiRefreshLine,
//   RiMailLine,
//   RiPhoneLine,
//   RiUserLine,
//   RiFileTextLine,
//   RiCalendarLine,
//   RiNewspaperLine,
//   RiPriceTag3Line,
//   RiPercentLine,
//   RiLayoutColumnLine,
//   RiEyeLine,
//   RiBuildingLine,
//   RiAddLine,
//   RiCheckboxCircleLine,
//   RiTimeLine,
//   RiArrowUpLine,
//   RiArrowDownSLine,
//   RiShieldKeyholeLine,
//   RiSendPlaneLine,
//   RiEditLine,
// } from "react-icons/ri";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";
// import { RiDownloadLine } from "react-icons/ri";
// import { generateReleaseOrderPDF } from "../Util/GenerateReleaseOrderPDF";
// import ROPreviewModal from "./Ropreviewmodal";
// import { RO_IMAGE_BASE64 } from "../Util/GenerateReleaseOrderPDF";

// const BASE_URL = `${process.env.REACT_APP_API_URL}/releaseOrder`;

// const Spinner = ({ className = "w-4 h-4" }) => (
//   <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
// );

// const Toast = ({ message, type, onClose }) => {
//   useEffect(() => {
//     const t = setTimeout(onClose, 5000);
//     return () => clearTimeout(t);
//   }, []);
//   return (
//     <div
//       className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
//       ${
//         type === "success"
//           ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
//           : "bg-red-50 border border-red-200 text-red-800"
//       }`}
//     >
//       {type === "success" ? (
//         <RiCheckLine className="w-4 h-4 text-emerald-500" />
//       ) : (
//         <RiErrorWarningLine className="w-4 h-4 text-red-500" />
//       )}
//       <span>{message}</span>
//       <button
//         onClick={onClose}
//         className="ml-2 opacity-50 hover:opacity-100 transition"
//       >
//         <RiCloseLine className="w-4 h-4" />
//       </button>
//     </div>
//   );
// };

// const Modal = ({ title, onClose, children, maxWidth = "max-w-3xl" }) =>
//   createPortal(
//     <div className="fixed inset-0 z-40 flex items-center justify-center">
//       <div
//         className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
//         onClick={onClose}
//       />
//       <div
//         className={`relative z-10 w-full ${maxWidth} mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden`}
//       >
//         <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
//           <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
//             {title}
//           </h2>
//           <button
//             onClick={onClose}
//             className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
//           >
//             <RiCloseLine className="w-5 h-5" />
//           </button>
//         </div>
//         <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
//           {children}
//         </div>
//       </div>
//     </div>,
//     document.body,
//   );

// const formatDate = (dateStr) => {
//   if (!dateStr) return "—";
//   return new Date(dateStr).toLocaleDateString("en-IN", {
//     day: "2-digit",
//     month: "short",
//     year: "numeric",
//   });
// };

// const InfoRow = ({ icon: Icon, label, value }) => (
//   <div className="flex items-start gap-3 py-2 border-b border-blue-50 last:border-0">
//     <div className="w-7 h-7 rounded-md bg-blue-50 border border-blue-100 flex items-center justify-center flex-shrink-0 mt-0.5">
//       <Icon className="w-3.5 h-3.5 text-blue-500" />
//     </div>
//     <div className="min-w-0">
//       <p className="text-[10px] font-semibold text-blue-400 uppercase tracking-widest">
//         {label}
//       </p>
//       <p className="text-sm text-slate-700 font-medium truncate">
//         {value || "—"}
//       </p>
//     </div>
//   </div>
// );

// const ItemCard = ({ item }) => (
//   <div className="bg-blue-50/40 border border-blue-100 rounded-xl p-4 mb-3 last:mb-0">
//     <div className="flex items-center justify-between mb-3">
//       <div className="flex items-center gap-2">
//         <div className="w-7 h-7 rounded-md bg-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm">
//           {(item.media?.organisation || "?")[0].toUpperCase()}
//         </div>
//         <span className="text-sm font-semibold text-slate-800">
//           {item.media?.organisation || "—"}
//         </span>
//       </div>
//       <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-blue-100 text-blue-600">
//         {item.hue || "—"}
//       </span>
//     </div>
//     <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 text-xs text-slate-500 mb-3">
//       <div>
//         <span className="text-blue-400 font-semibold">Publication:</span>{" "}
//         {item.publication || "—"}
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">Edition:</span>{" "}
//         {item.edition || "—"}
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">Ad Type:</span>{" "}
//         {item.adType || "—"}
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">Page:</span>{" "}
//         {item.pagePosition || "—"}
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">Size:</span> {item.width}{" "}
//         × {item.height} cm
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">DOP:</span>{" "}
//         {formatDate(item.dop)}
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">Rate/Sq Cm:</span> ₹
//         {item.ratePerSqCm}
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">GST:</span> {item.gst}%
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">Agency Comm:</span>{" "}
//         {item.agencyCommission}%
//       </div>
//       <div>
//         <span className="text-blue-400 font-semibold">Other Disc:</span>{" "}
//         {item.otherDiscount}%
//       </div>
//     </div>
//     <div className="flex items-center justify-between pt-2 border-t border-blue-100">
//       <div className="text-xs text-slate-400">
//         Gross:{" "}
//         <span className="font-semibold text-slate-600">
//           ₹{item.totalGross?.toLocaleString("en-IN")}
//         </span>
//       </div>
//       <div className="text-sm font-bold text-blue-700">
//         Net: ₹
//         {item.netPayableAmount?.toLocaleString("en-IN", {
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2,
//         })}
//       </div>
//     </div>
//   </div>
// );

// const InvoiceStatusBadge = ({ status }) => {
//   const isPending = !status || status === "pending";
//   return (
//     <span
//       className={`inline-flex items-center gap-1 text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider
//         ${isPending ? "bg-amber-100 text-amber-700 border border-amber-200" : "bg-emerald-100 text-emerald-700 border border-emerald-200"}`}
//     >
//       {isPending ? (
//         <RiTimeLine className="w-3 h-3" />
//       ) : (
//         <RiCheckboxCircleLine className="w-3 h-3" />
//       )}
//       {isPending ? "Pending" : "Complete"}
//     </span>
//   );
// };

// // ─── OTP Input — 6 individual boxes ──────────────────────────────────────────
// const OtpInput = ({ value, onChange }) => {
//   const refs = useRef([]);
//   const digits = (value + "      ").slice(0, 6).split("");

//   const handleKey = (idx, e) => {
//     if (e.key === "Backspace") {
//       const newVal = value.slice(0, idx) + " " + value.slice(idx + 1);
//       onChange(newVal.trimEnd());
//       if (idx > 0) refs.current[idx - 1]?.focus();
//       return;
//     }
//     if (!/^\d$/.test(e.key)) return;
//     const newVal =
//       value.padEnd(idx, " ").slice(0, idx) + e.key + value.slice(idx + 1);
//     onChange(
//       newVal
//         .replace(/ /g, "")
//         .slice(0, 6)
//         .padEnd(Math.min(idx + 1, 6), "")
//         .trimEnd(),
//     );
//     if (idx < 5) refs.current[idx + 1]?.focus();
//   };

//   return (
//     <div className="flex gap-2 justify-center my-4">
//       {Array.from({ length: 6 }).map((_, idx) => (
//         <input
//           key={idx}
//           ref={(el) => (refs.current[idx] = el)}
//           type="text"
//           inputMode="numeric"
//           maxLength={1}
//           value={digits[idx]?.trim() || ""}
//           onChange={() => {}}
//           onKeyDown={(e) => handleKey(idx, e)}
//           onPaste={(e) => {
//             const pasted = e.clipboardData
//               .getData("text")
//               .replace(/\D/g, "")
//               .slice(0, 6);
//             onChange(pasted);
//             refs.current[Math.min(pasted.length, 5)]?.focus();
//             e.preventDefault();
//           }}
//           onFocus={(e) => e.target.select()}
//           className="w-11 h-13 text-center text-xl font-bold border-2 rounded-xl focus:outline-none transition
//             bg-red-50 border-red-200 text-red-700 focus:border-red-500 focus:ring-2 focus:ring-red-500/20"
//         />
//       ))}
//     </div>
//   );
// };

// // ─── Delete with OTP Modal ────────────────────────────────────────────────────
// const DeleteOtpModal = ({ variant, onClose, onDeleted, notify }) => {
//   const [step, setStep] = useState("confirm");
//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [otpSentMsg, setOtpSentMsg] = useState("");
//   const [otp, setOtp] = useState("");
//   const [deleting, setDeleting] = useState(false);
//   const [countdown, setCountdown] = useState(0);

//   useEffect(() => {
//     if (countdown <= 0) return;
//     const t = setTimeout(() => setCountdown((c) => c - 1), 5000);
//     return () => clearTimeout(t);
//   }, [countdown]);

//   const handleSendOtp = async () => {
//     setSendingOtp(true);
//     setOtpSentMsg("");
//     try {
//       const res = await axios.post(`${BASE_URL}/delete-otp/${variant._id}`);
//       setOtpSentMsg(res.data?.message || "OTP sent to admin email");
//       setStep("otp");
//       setCountdown(60);
//     } catch (err) {
//       notify(err?.response?.data?.message || "Failed to send OTP", "error");
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   const handleDelete = async () => {
//     if (otp.length < 6) {
//       notify("Please enter the complete 6-digit OTP", "error");
//       return;
//     }
//     setDeleting(true);
//     try {
//       await axios.delete(`${BASE_URL}/delete/${variant._id}`, {
//         data: { otp },
//       });
//       notify("Release order deleted successfully");
//       onDeleted();
//       onClose();
//     } catch (err) {
//       notify(
//         err?.response?.data?.message || "Failed to delete release order",
//         "error",
//       );
//     } finally {
//       setDeleting(false);
//     }
//   };

//   return (
//     <Modal
//       title={
//         <>
//           <RiDeleteBinLine className="w-5 h-5 text-red-500" />
//           {step === "confirm" ? "Confirm Deletion" : "Enter OTP to Delete"}
//         </>
//       }
//       onClose={onClose}
//       maxWidth="max-w-md"
//     >
//       {step === "confirm" ? (
//         <div className="text-center py-2">
//           <div className="w-16 h-16 rounded-full bg-red-50 border-2 border-red-100 flex items-center justify-center mx-auto mb-4">
//             <RiErrorWarningLine className="w-8 h-8 text-red-500" />
//           </div>
//           <p className="text-slate-700 font-semibold mb-1 text-base">
//             Delete{" "}
//             <span className="text-red-500 font-mono">{variant?.roNumber}</span>?
//           </p>
//           <p className="text-slate-400 text-sm mb-3">
//             This action is{" "}
//             <strong className="text-red-500">irreversible</strong>. All data for
//             this release order will be permanently removed.
//           </p>
//           <div className="flex items-start gap-3 bg-amber-50 border border-amber-200 rounded-xl p-3 mb-6 text-left">
//             <RiShieldKeyholeLine className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
//             <p className="text-xs text-amber-700">
//               For security, an{" "}
//               <strong>OTP will be sent to the admin email</strong> to confirm
//               this deletion.
//             </p>
//           </div>
//           <div className="flex justify-center gap-3">
//             <button
//               onClick={onClose}
//               className="flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition font-semibold"
//             >
//               <RiCloseLine className="w-4 h-4" /> Cancel
//             </button>
//             <button
//               onClick={handleSendOtp}
//               disabled={sendingOtp}
//               className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold bg-red-500 hover:bg-red-600 text-white transition shadow-md shadow-red-100 disabled:opacity-60"
//             >
//               {sendingOtp ? (
//                 <Spinner />
//               ) : (
//                 <RiSendPlaneLine className="w-4 h-4" />
//               )}
//               {sendingOtp ? "Sending OTP…" : "Send OTP"}
//             </button>
//           </div>
//         </div>
//       ) : (
//         <div className="text-center py-2">
//           <div className="w-16 h-16 rounded-full bg-red-50 border-2 border-red-200 flex items-center justify-center mx-auto mb-3">
//             <RiShieldKeyholeLine className="w-8 h-8 text-red-500" />
//           </div>
//           <p className="text-slate-700 font-semibold text-base mb-1">
//             Verify OTP
//           </p>
//           {otpSentMsg && (
//             <p className="text-xs text-emerald-600 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2 mb-1 inline-block">
//               ✓ {otpSentMsg}
//             </p>
//           )}
//           <p className="text-slate-400 text-sm mb-2">
//             Enter the 6-digit OTP to confirm deletion of{" "}
//             <span className="font-mono font-semibold text-red-500">
//               {variant?.roNumber}
//             </span>
//           </p>
//           <OtpInput value={otp} onChange={setOtp} />
//           <div className="flex items-center justify-center gap-2 mb-5">
//             {countdown > 0 ? (
//               <span className="text-xs text-slate-400">
//                 Resend OTP in{" "}
//                 <span className="font-semibold text-slate-600">
//                   {countdown}s
//                 </span>
//               </span>
//             ) : (
//               <button
//                 onClick={handleSendOtp}
//                 disabled={sendingOtp}
//                 className="text-xs text-blue-600 hover:text-blue-700 font-semibold transition disabled:opacity-50"
//               >
//                 {sendingOtp ? "Sending…" : "Resend OTP"}
//               </button>
//             )}
//           </div>
//           <div className="flex justify-center gap-3">
//             <button
//               onClick={onClose}
//               className="flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition font-semibold"
//             >
//               <RiCloseLine className="w-4 h-4" /> Cancel
//             </button>
//             <button
//               onClick={handleDelete}
//               disabled={deleting || otp.length < 6}
//               className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold bg-red-500 hover:bg-red-600 text-white transition shadow-md shadow-red-100 disabled:opacity-60"
//             >
//               {deleting ? <Spinner /> : <RiDeleteBinLine className="w-4 h-4" />}
//               {deleting ? "Deleting…" : "Confirm Delete"}
//             </button>
//           </div>
//         </div>
//       )}
//     </Modal>
//   );
// };

// // ─── Main Component ───────────────────────────────────────────────────────────
// export default function AllRo() {
//   const navigate = useNavigate();
//   const [roGroups, setRoGroups] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modal, setModal] = useState(null);
//   const [selected, setSelected] = useState(null);
//   const [toast, setToast] = useState(null);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [expandedRows, setExpandedRows] = useState(new Set());
//   const [previewGroup, setPreviewGroup] = useState(null);
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);

//   const notify = (message, type = "success") => setToast({ message, type });

//   const fetchROs = async (pageNo = page, searchText = search) => {
//     setLoading(true);

//     try {
//       const res = await axios.get(
//         `${BASE_URL}/all?page=${pageNo}&limit=10&search=${searchText}`,
//       );

//       setRoGroups(res.data?.data || []);
//       setPage(res.data?.pagination?.currentPage || 1);
//       setTotalPages(res.data?.pagination?.totalPages || 1);
//     } catch {
//       notify("Failed to fetch release orders", "error");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getAdminData = () => {
//     try {
//       const raw = localStorage.getItem("Nexgen-Admin-Data");
//       return raw ? JSON.parse(raw) : null;
//     } catch {
//       return null;
//     }
//   };

//   const handlePreviewGroup = (group) => {
//     const clientName = group.client?.bankName || group.client?.name || "";
//     const allItems = (group.variants || []).flatMap((v) =>
//       (v.items || []).map((item) => ({
//         ...item,
//         roNumber: v.roNumber,
//         rate: item.ratePerSqCm || item.rate || 0,
//         width: parseFloat(item.width) || 0,
//         height: parseFloat(item.height) || 0,
//         agencyCommission: parseFloat(item.agencyCommission) || 0,
//         otherDiscount: parseFloat(item.otherDiscount) || 0,
//         cashDiscount: parseFloat(item.cashDiscount) || 0,
//         gst: parseFloat(item.gst) || 0,
//         publication: item.publication || item.media?.organisation || "",
//         adType: item.adType || "",
//         edition: item.edition || "",
//         hue: item.hue || "B/W",
//         dop: item.dop || "",
//         pagePosition: item.pagePosition || "",
//         totalGross: item.totalGross || item.grossAmount || 0,
//         netPayableAmount: item.netPayableAmount || 0,
//       })),
//     );

//     setPreviewGroup({
//       roNumber: group.baseRONumber || "",
//       date: group.date || "",
//       caption: group.variants?.[0]?.caption || "",
//       createdAt: group.createdAt || group.date || "",
//       client: group.client,
//       items: allItems,
//     });
//   };

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       fetchROs(1, search);
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [search]);

//   const openView = (variant) => {
//     setSelected(variant);
//     setModal("view");
//   };
//   const openDelete = (variant) => {
//     setSelected(variant);
//     setModal("delete");
//   };
//   const openEdit = (variant) => {
//     navigate(`/admin/edit-release-order/${variant._id}`);
//   };
//   const closeModal = () => {
//     setModal(null);
//     setSelected(null);
//   };

//   const handleDownloadPDF = async (variantId) => {
//     try {
//       const res = await axios.get(`${BASE_URL}/${variantId}`);
//       const roData = res.data?.data || res.data;
//       if (!roData) {
//         notify("No data received from server", "error");
//         return;
//       }
//       const normalizedRO = {
//         roNumber: roData.roNumber || "",
//         date: roData.date || "",
//         caption: roData.caption || "",
//         createdAt: roData.createdAt || "",
//         client: {
//           ...roData.client,
//           bankName: roData.client?.bankName || roData.client?.name || "",
//         },
//         staff: roData.staff || undefined,
//         agent: roData.agent || undefined,
//         items: (roData.items || []).map((item) => ({
//           ...item,
//           roNumber: roData.roNumber || "",
//           rate: item.ratePerSqCm || item.rate || 0,
//           width: parseFloat(item.width) || 0,
//           height: parseFloat(item.height) || 0,
//           agencyCommission: parseFloat(item.agencyCommission) || 0,
//           otherDiscount: parseFloat(item.otherDiscount) || 0,
//           cashDiscount: parseFloat(item.cashDiscount) || 0,
//           gst: parseFloat(item.gst) || 0,
//           publication: item.publication || item.media?.organisation || "",
//           adType: item.adType || "",
//           edition: item.edition || "",
//           hue: item.hue || "B/W",
//           dop: item.dop || "",
//           pagePosition: item.pagePosition || "",
//           totalGross: item.totalGross || item.grossAmount || 0,
//           netPayableAmount: item.netPayableAmount || 0,
//         })),
//       };
//       if (normalizedRO.items.length === 0) {
//         notify("No items found in this release order", "error");
//         return;
//       }
//       generateReleaseOrderPDF(normalizedRO);
//     } catch (err) {
//       notify(err?.response?.data?.message || "Failed to download PDF", "error");
//     }
//   };

//   const handleCreateInvoice = (baseRONumber) => {
//     const parts = baseRONumber.split("/");
//     if (parts.length === 3) {
//       navigate(
//         `/create-Invoice-by-releaseorder/${parts[0]}/${parts[1]}/${parts[2]}`,
//       );
//     } else {
//       notify("Invalid RO number format", "error");
//     }
//   };

//   const toggleExpand = (baseRONumber) => {
//     const newExpanded = new Set(expandedRows);
//     if (newExpanded.has(baseRONumber)) newExpanded.delete(baseRONumber);
//     else newExpanded.add(baseRONumber);
//     setExpandedRows(newExpanded);
//   };

//   const filtered = roGroups;

//   const tableHeaders = [
//     { label: "Base RO Number", Icon: RiFileTextLine },
//     { label: "Client", Icon: RiBuildingLine },
//     { label: "Variants", Icon: RiLayoutColumnLine },
//     { label: "Date", Icon: RiCalendarLine },
//     { label: "Items Count", Icon: RiNewspaperLine },
//     { label: "Total Net Payable", Icon: RiPriceTag3Line },
//     { label: "Status" },
//     { label: "Actions" },
//   ];

//   const getTotalNetForGroup = (variants = []) =>
//     variants.reduce((sum, v) => {
//       const variantTotal =
//         v.items?.reduce((vsum, i) => vsum + (i.netPayableAmount || 0), 0) || 0;
//       return sum + variantTotal;
//     }, 0);

//   const getTotalNetForVariant = (items = []) =>
//     items.reduce((sum, i) => sum + (i.netPayableAmount || 0), 0);

//   const pendingCount = roGroups.filter((g) =>
//     g.variants?.every((v) => !v.invoiceStatus || v.invoiceStatus === "pending"),
//   ).length;

//   const completeCount = roGroups.filter((g) =>
//     g.variants?.every((v) => v.invoiceStatus && v.invoiceStatus !== "pending"),
//   ).length;

//   return (
//     <div className="min-h-screen bg-white text-slate-800">
//       <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
//         <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
//               <RiFileTextLine className="w-5 h-5" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-blue-800 tracking-tight">
//                 Release Orders
//               </h1>
//               <p className="text-[11px] text-blue-400 tracking-widest uppercase">
//                 RO Management
//               </p>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <div className="relative">
//               <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
//               <input
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 placeholder="Search ROs…"
//                 className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
//               />
//             </div>
//             <button
//               onClick={() => fetchROs(page)}
//               disabled={loading}
//               title="Refresh"
//               className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
//             >
//               <RiRefreshLine
//                 className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
//               />
//             </button>
//           </div>
//         </div>
//       </header>

//       <div className="w-full mx-auto px-6 pt-6 pb-10">
//         {/* Stats row */}
//         <div className="flex items-center gap-3 mb-5 flex-wrap">
//           {[
//             {
//               key: "all",
//               label: "All Orders",
//               count: roGroups.length,
//               activeClass:
//                 "bg-blue-600 text-white border-blue-600 shadow-md shadow-blue-200",
//               countClass: "bg-white/20 text-white",
//               inactiveClass:
//                 "bg-white text-slate-500 border-blue-100 hover:border-blue-300",
//               inactiveCountClass: "bg-blue-100 text-blue-600",
//             },
//             {
//               key: "pending",
//               label: "Pending Invoice",
//               count: pendingCount,
//               Icon: RiTimeLine,
//               activeClass:
//                 "bg-amber-500 text-white border-amber-500 shadow-md shadow-amber-200",
//               countClass: "bg-white/20 text-white",
//               inactiveClass:
//                 "bg-white text-slate-500 border-blue-100 hover:border-amber-300",
//               inactiveCountClass: "bg-amber-100 text-amber-700",
//             },
//             {
//               key: "complete",
//               label: "Invoice Complete",
//               count: completeCount,
//               Icon: RiCheckboxCircleLine,
//               activeClass:
//                 "bg-emerald-600 text-white border-emerald-600 shadow-md shadow-emerald-200",
//               countClass: "bg-white/20 text-white",
//               inactiveClass:
//                 "bg-white text-slate-500 border-blue-100 hover:border-emerald-300",
//               inactiveCountClass: "bg-emerald-100 text-emerald-700",
//             },
//           ].map(
//             ({
//               key,
//               label,
//               count,
//               Icon,
//               activeClass,
//               countClass,
//               inactiveClass,
//               inactiveCountClass,
//             }) => (
//               <button
//                 key={key}
//                 onClick={() => setStatusFilter(key)}
//                 className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold border transition
//                 ${statusFilter === key ? activeClass : inactiveClass}`}
//               >
//                 {Icon && <Icon className="w-3.5 h-3.5" />}
//                 {label}
//                 <span
//                   className={`px-1.5 py-0.5 rounded-full text-[10px] font-bold ${statusFilter === key ? countClass : inactiveCountClass}`}
//                 >
//                   {count}
//                 </span>
//               </button>
//             ),
//           )}
//         </div>

//         {/* Table */}
//         <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
//           <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
//             <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
//               <RiFileTextLine className="w-4 h-4 text-blue-500" />
//               {statusFilter === "all"
//                 ? "All Release Orders"
//                 : statusFilter === "pending"
//                   ? "Pending Invoice ROs"
//                   : "Invoice Complete ROs"}
//             </span>
//             <span className="text-xs text-blue-400">
//               {filtered.length} group{filtered.length !== 1 ? "s" : ""}
//             </span>
//           </div>

//           <div className="overflow-x-auto">
//             <table className="w-full text-sm">
//               <thead>
//                 <tr className="border-b border-blue-100 bg-blue-50/30">
//                   {tableHeaders.map(({ label, Icon }) => (
//                     <th key={label} className="px-4 py-3 text-left">
//                       <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
//                         {Icon && <Icon className="w-3.5 h-3.5" />}
//                         {label}
//                       </span>
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan={8} className="py-20 text-center">
//                       <div className="flex flex-col items-center gap-3 text-blue-400">
//                         <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
//                         <span className="text-sm">Loading release orders…</span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : filtered.length === 0 ? (
//                   <tr>
//                     <td colSpan={8} className="py-20 text-center">
//                       <div className="flex flex-col items-center gap-3">
//                         <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
//                           <RiFileTextLine className="w-7 h-7 text-blue-300" />
//                         </div>
//                         <span className="text-sm text-slate-400">
//                           {search
//                             ? "No release orders match your search."
//                             : "No release orders found."}
//                         </span>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : (
//                   filtered.map((group, groupIdx) => {
//                     const isExpanded = expandedRows.has(group.baseRONumber);
//                     const groupTotal = getTotalNetForGroup(group.variants);
//                     const allPending = group.variants?.every(
//                       (v) => !v.invoiceStatus || v.invoiceStatus === "pending",
//                     );

//                     return (
//                       <React.Fragment key={group.baseRONumber || groupIdx}>
//                         <tr
//                           className={`border-b border-blue-50 transition group ${allPending ? "hover:bg-amber-50/40 cursor-pointer" : "hover:bg-blue-50/50"}`}
//                         >
//                           <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
//                             <div className="flex items-center gap-2.5">
//                               <button
//                                 onClick={() => toggleExpand(group.baseRONumber)}
//                                 className="flex-shrink-0 text-blue-500 hover:text-blue-700 transition"
//                               >
//                                 {isExpanded ? (
//                                   <RiArrowUpLine className="w-4 h-4" />
//                                 ) : (
//                                   <RiArrowDownSLine className="w-4 h-4" />
//                                 )}
//                               </button>
//                               <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm shadow-blue-200 flex-shrink-0">
//                                 <RiFileTextLine className="w-4 h-4" />
//                               </div>
//                               <span className="text-blue-700 font-mono text-xs font-bold">
//                                 {group.baseRONumber || "—"}
//                               </span>
//                             </div>
//                           </td>
//                           <td className="px-4 py-3 whitespace-nowrap">
//                             <div className="flex items-center gap-2">
//                               {group.client?.bankLogo ? (
//                                 <img
//                                   src={group.client.bankLogo}
//                                   alt=""
//                                   className="w-6 h-6 rounded object-contain border border-blue-100 bg-white"
//                                 />
//                               ) : (
//                                 <div className="w-6 h-6 rounded bg-blue-100 flex items-center justify-center">
//                                   <RiBuildingLine className="w-3.5 h-3.5 text-blue-400" />
//                                 </div>
//                               )}
//                               <span className="text-slate-700 text-sm font-medium">
//                                 {group.client?.bankName || "—"}
//                               </span>
//                             </div>
//                           </td>
//                           <td className="px-4 py-3">
//                             <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-blue-100 text-blue-600">
//                               {group.variants?.length || 0} variant
//                               {(group.variants?.length || 0) !== 1 ? "s" : ""}
//                             </span>
//                           </td>
//                           <td className="px-4 py-3 text-slate-500 whitespace-nowrap">
//                             {formatDate(group.date)}
//                           </td>
//                           <td className="px-4 py-3">
//                             <span className="text-xs font-semibold text-slate-600">
//                               {group.variants?.reduce(
//                                 (sum, v) => sum + (v.items?.length || 0),
//                                 0,
//                               ) || 0}{" "}
//                               items
//                             </span>
//                           </td>
//                           <td className="px-4 py-3 whitespace-nowrap">
//                             <span className="text-sm font-bold text-blue-700">
//                               ₹
//                               {groupTotal.toLocaleString("en-IN", {
//                                 minimumFractionDigits: 2,
//                                 maximumFractionDigits: 2,
//                               })}
//                             </span>
//                           </td>
//                           <td className="px-4 py-3">
//                             <InvoiceStatusBadge
//                               status={allPending ? "pending" : "complete"}
//                             />
//                           </td>
//                           <td className="px-4 py-3">
//                             <div className="flex gap-2 flex-wrap">
//                               <button
//                                 onClick={() => toggleExpand(group.baseRONumber)}
//                                 className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//                               >
//                                 <RiEyeLine className="w-3.5 h-3.5" />
//                                 {isExpanded ? "Hide" : "View"} Variants
//                               </button>
//                               <button
//                                 onClick={() => handlePreviewGroup(group)}
//                                 className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-violet-50 border border-violet-200 text-violet-600 hover:bg-violet-100 font-semibold transition"
//                               >
//                                 <RiEyeLine className="w-3.5 h-3.5" /> Preview RO
//                               </button>
//                               {allPending && (
//                                 <button
//                                   onClick={() =>
//                                     handleCreateInvoice(group.baseRONumber)
//                                   }
//                                   className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-indigo-600 border border-indigo-600 text-white hover:bg-indigo-700 font-semibold transition shadow-sm shadow-indigo-200"
//                                 >
//                                   <RiAddLine className="w-3.5 h-3.5" /> Invoice
//                                 </button>
//                               )}
//                             </div>
//                           </td>
//                         </tr>

//                         {isExpanded && (
//                           <tr className="border-b border-indigo-200 bg-indigo-100/60">
//                             <td className="px-4 py-2 pl-12">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 RO Number
//                               </span>
//                             </td>
//                             <td className="px-4 py-2">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 Media
//                               </span>
//                             </td>
//                             <td className="px-4 py-2">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 Edition
//                               </span>
//                             </td>
//                             <td className="px-4 py-2">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 Hue
//                               </span>
//                             </td>
//                             <td className="px-4 py-2">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 Size (cm)
//                               </span>
//                             </td>
//                             <td className="px-4 py-2">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 Rate/sq cm
//                               </span>
//                             </td>
//                             <td className="px-4 py-2">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 DOP
//                               </span>
//                             </td>
//                             <td className="px-4 py-2">
//                               <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
//                                 Net Amount / Actions
//                               </span>
//                             </td>
//                           </tr>
//                         )}

//                         {isExpanded &&
//                           group.variants &&
//                           group.variants.flatMap((variant, varIdx) =>
//                             (variant.items?.length > 0
//                               ? variant.items
//                               : [null]
//                             ).map((item, iIdx) => {
//                               const variantTotal = getTotalNetForVariant(
//                                 variant.items,
//                               );
//                               const isFirstItem = iIdx === 0;
//                               const isLastItem =
//                                 iIdx === (variant.items?.length || 1) - 1;

//                               return (
//                                 <tr
//                                   key={`${variant._id || varIdx}-${iIdx}`}
//                                   className={`border-b border-indigo-50 transition
//             ${iIdx % 2 === 0 ? "bg-indigo-50/20" : "bg-white"}
//             ${isLastItem ? "border-b-2 border-indigo-100" : ""}
//           `}
//                                 >
//                                   {/* RO Number — only on first item row */}
//                                   <td
//                                     className="px-4 py-2.5 whitespace-nowrap pl-12"
//                                     rowSpan={
//                                       isFirstItem
//                                         ? variant.items?.length || 1
//                                         : undefined
//                                     }
//                                     style={
//                                       !isFirstItem ? { display: "none" } : {}
//                                     }
//                                   >
//                                     {isFirstItem && (
//                                       <div className="flex items-center gap-2">
//                                         <div className="w-7 h-7 rounded-lg bg-indigo-600 flex items-center justify-center text-white text-xs font-bold shadow-sm flex-shrink-0">
//                                           {variant.roNumber
//                                             ?.split("(")[1]
//                                             ?.charAt(0) || "V"}
//                                         </div>
//                                         <span className="text-indigo-700 font-mono text-xs font-bold whitespace-nowrap">
//                                           {variant.roNumber || "—"}
//                                         </span>
//                                       </div>
//                                     )}
//                                   </td>

//                                   {/* Media */}
//                                   <td className="px-4 py-2.5">
//                                     {item ? (
//                                       <div className="flex items-center gap-2">
//                                         <div className="w-5 h-5 rounded bg-indigo-600 flex items-center justify-center text-white text-[10px] font-bold flex-shrink-0">
//                                           {(item.media?.organisation ||
//                                             item.publication ||
//                                             "?")[0].toUpperCase()}
//                                         </div>
//                                         <span className="text-xs font-semibold text-slate-700 whitespace-nowrap">
//                                           {item.media?.organisation ||
//                                             item.publication ||
//                                             "—"}
//                                         </span>
//                                       </div>
//                                     ) : (
//                                       <span className="text-slate-300 text-xs">
//                                         —
//                                       </span>
//                                     )}
//                                   </td>

//                                   {/* Edition */}
//                                   <td className="px-4 py-2.5 text-xs text-slate-600 whitespace-nowrap">
//                                     {item?.edition || "—"}
//                                   </td>

//                                   {/* Hue */}
//                                   <td className="px-4 py-2.5">
//                                     {item && (
//                                       <span
//                                         className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold
//                 ${
//                   item.hue === "Color"
//                     ? "bg-violet-100 text-violet-600 border border-violet-200"
//                     : "bg-slate-100 text-slate-500 border border-slate-200"
//                 }`}
//                                       >
//                                         {item.hue || "B/W"}
//                                       </span>
//                                     )}
//                                   </td>

//                                   {/* Size */}
//                                   <td className="px-4 py-2.5 text-xs text-slate-600 font-mono whitespace-nowrap">
//                                     {item
//                                       ? `${item.width} × ${item.height}`
//                                       : "—"}
//                                   </td>

//                                   {/* Rate/sq cm */}
//                                   <td className="px-4 py-2.5 text-xs text-slate-600 whitespace-nowrap">
//                                     {item
//                                       ? `₹${(item.ratePerSqCm || item.rate || 0).toLocaleString("en-IN")}`
//                                       : "—"}
//                                   </td>

//                                   {/* DOP */}
//                                   <td className="px-4 py-2.5 text-xs text-slate-500 whitespace-nowrap">
//                                     {item ? formatDate(item.dop) : "—"}
//                                   </td>

//                                   {/* Net Amount + Actions on first item only */}
//                                   <td className="px-4 py-2.5 whitespace-nowrap">
//                                     {item ? (
//                                       <div className="flex items-center justify-between gap-4">
//                                         <span className="text-xs font-bold text-indigo-700">
//                                           ₹
//                                           {(
//                                             item.netPayableAmount || 0
//                                           ).toLocaleString("en-IN", {
//                                             minimumFractionDigits: 2,
//                                             maximumFractionDigits: 2,
//                                           })}
//                                         </span>
//                                         {isFirstItem && (
//                                           <div className="flex gap-1.5 flex-wrap">
//                                             <button
//                                               onClick={() => openView(variant)}
//                                               className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//                                             >
//                                               <RiEyeLine className="w-3 h-3" />{" "}
//                                               View
//                                             </button>
//                                             <button
//                                               onClick={() =>
//                                                 handleDownloadPDF(variant._id)
//                                               }
//                                               className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-600 hover:bg-emerald-100 font-semibold transition"
//                                             >
//                                               <RiDownloadLine className="w-3 h-3" />{" "}
//                                               PDF
//                                             </button>
//                                             <button
//                                               onClick={() => openEdit(variant)}
//                                               className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-amber-50 border border-amber-200 text-amber-600 hover:bg-amber-100 font-semibold transition"
//                                             >
//                                               <RiEditLine className="w-3 h-3" />{" "}
//                                               Edit
//                                             </button>
//                                             <button
//                                               onClick={() =>
//                                                 openDelete(variant)
//                                               }
//                                               className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
//                                             >
//                                               <RiDeleteBinLine className="w-3 h-3" />{" "}
//                                               Delete
//                                             </button>
//                                           </div>
//                                         )}
//                                       </div>
//                                     ) : (
//                                       isFirstItem && (
//                                         <div className="flex gap-1.5">
//                                           <button
//                                             onClick={() => openView(variant)}
//                                             className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
//                                           >
//                                             <RiEyeLine className="w-3 h-3" />{" "}
//                                             View
//                                           </button>
//                                           <button
//                                             onClick={() => openDelete(variant)}
//                                             className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
//                                           >
//                                             <RiDeleteBinLine className="w-3 h-3" />{" "}
//                                             Delete
//                                           </button>
//                                         </div>
//                                       )
//                                     )}
//                                   </td>
//                                 </tr>
//                               );
//                             }),
//                           )}
//                       </React.Fragment>
//                     );
//                   })
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       <div className="flex items-center justify-end gap-2 mt-4">
//         <button
//           disabled={page === 1}
//           onClick={() => fetchROs(page - 1)}
//           className="px-4 py-2 text-sm rounded-lg border border-blue-200 bg-white text-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
//         >
//           Previous
//         </button>

//         <span className="px-3 text-sm font-medium text-slate-600">
//           Page {page} of {totalPages}
//         </span>

//         <button
//           disabled={page === totalPages}
//           onClick={() => fetchROs(page + 1)}
//           className="px-4 py-2 text-sm rounded-lg border border-blue-200 bg-white text-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
//         >
//           Next
//         </button>
//       </div>

//       {/* View Modal */}
//       {modal === "view" && selected && (
//         <Modal
//           title={
//             <>
//               <RiFileTextLine className="w-5 h-5 text-blue-500" />
//               {selected.roNumber}
//             </>
//           }
//           onClose={closeModal}
//         >
//           <div className="grid grid-cols-2 gap-4 mb-5">
//             <div className="col-span-2 bg-blue-50 border border-blue-100 rounded-xl p-4">
//               <p className="text-[10px] font-semibold text-blue-400 uppercase tracking-widest mb-1">
//                 Caption
//               </p>
//               <p className="text-base font-semibold text-slate-800">
//                 {selected.caption || "—"}
//               </p>
//             </div>
//             <InfoRow
//               icon={RiBuildingLine}
//               label="Client"
//               value={selected.client?.bankName}
//             />
//             <InfoRow
//               icon={RiCalendarLine}
//               label="RO Date"
//               value={formatDate(selected.date)}
//             />
//             <InfoRow
//               icon={RiUserLine}
//               label="Agent"
//               value={selected.agent?.name}
//             />
//             <InfoRow
//               icon={RiPhoneLine}
//               label="Agent Phone"
//               value={selected.agent?.number}
//             />
//             <InfoRow
//               icon={RiMailLine}
//               label="Agent Email"
//               value={selected.agent?.email}
//             />
//             <InfoRow
//               icon={RiPercentLine}
//               label="Client Head Office"
//               value={selected.client?.headOffice}
//             />
//             <div className="mt-4 pt-4 border-t border-blue-100 flex gap-3">
//               <button
//                 onClick={() => handleDownloadPDF(selected._id)}
//                 className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold transition shadow-md shadow-emerald-200"
//               >
//                 <RiDownloadLine className="w-4 h-4" /> Download PDF
//               </button>
//             </div>
//           </div>
//           <div>
//             <p className="text-xs font-semibold text-blue-700 uppercase tracking-widest mb-3 flex items-center gap-2">
//               <RiLayoutColumnLine className="w-4 h-4" />
//               Ad Items ({selected.items?.length || 0})
//             </p>
//             {selected.items?.length > 0 ? (
//               selected.items.map((item, idx) => (
//                 <ItemCard key={item._id || idx} item={item} />
//               ))
//             ) : (
//               <p className="text-sm text-slate-400 text-center py-4">
//                 No items found.
//               </p>
//             )}
//           </div>
//           <div className="mt-4 pt-4 border-t border-blue-100 flex items-center justify-between">
//             <span className="text-sm text-slate-500 font-medium">
//               Total Net Payable
//             </span>
//             <span className="text-lg font-bold text-blue-700">
//               ₹
//               {getTotalNetForVariant(selected.items).toLocaleString("en-IN", {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//               })}
//             </span>
//           </div>
//         </Modal>
//       )}

//       {/* OTP Delete Modal */}
//       {modal === "delete" && selected && (
//         <DeleteOtpModal
//           variant={selected}
//           onClose={closeModal}
//           onDeleted={() => fetchROs(page)}
//           notify={notify}
//         />
//       )}
//       {previewGroup && (
//         <ROPreviewModal
//           roData={previewGroup}
//           roImageBase64={RO_IMAGE_BASE64}
//           onClose={() => setPreviewGroup(null)}
//         />
//       )}

//       {toast && <Toast {...toast} onClose={() => setToast(null)} />}
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  RiSearchLine,
  RiCloseLine,
  RiDeleteBinLine,
  RiCheckLine,
  RiErrorWarningLine,
  RiRefreshLine,
  RiMailLine,
  RiPhoneLine,
  RiUserLine,
  RiFileTextLine,
  RiCalendarLine,
  RiNewspaperLine,
  RiPriceTag3Line,
  RiPercentLine,
  RiLayoutColumnLine,
  RiEyeLine,
  RiBuildingLine,
  RiAddLine,
  RiCheckboxCircleLine,
  RiTimeLine,
  RiArrowUpLine,
  RiArrowDownSLine,
  RiEditLine,
} from "react-icons/ri";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { RiDownloadLine } from "react-icons/ri";
import { generateReleaseOrderPDF } from "../Util/GenerateReleaseOrderPDF";
import ROPreviewModal from "./Ropreviewmodal";
import { RO_IMAGE_BASE64 } from "../Util/GenerateReleaseOrderPDF";

const BASE_URL = `${process.env.REACT_APP_API_URL}/releaseOrder`;

// ─── Admin helper ─────────────────────────────────────────────────────────────
const getAdminData = () => {
  try {
    const raw = localStorage.getItem("Nexgen-Admin-Data");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const Spinner = ({ className = "w-4 h-4" }) => (
  <AiOutlineLoading3Quarters className={`animate-spin ${className}`} />
);

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 5000);
    return () => clearTimeout(t);
  }, []);
  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 px-5 py-3 rounded-xl shadow-xl text-sm font-medium
      ${
        type === "success"
          ? "bg-emerald-50 border border-emerald-200 text-emerald-800"
          : "bg-red-50 border border-red-200 text-red-800"
      }`}
    >
      {type === "success" ? (
        <RiCheckLine className="w-4 h-4 text-emerald-500" />
      ) : (
        <RiErrorWarningLine className="w-4 h-4 text-red-500" />
      )}
      <span>{message}</span>
      <button
        onClick={onClose}
        className="ml-2 opacity-50 hover:opacity-100 transition"
      >
        <RiCloseLine className="w-4 h-4" />
      </button>
    </div>
  );
};

const Modal = ({ title, onClose, children, maxWidth = "max-w-3xl" }) =>
  createPortal(
    <div className="fixed inset-0 z-40 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-blue-950/40 backdrop-blur-sm"
        onClick={onClose}
      />
      <div
        className={`relative z-10 w-full ${maxWidth} mx-4 bg-white border border-blue-100 rounded-2xl shadow-2xl overflow-hidden`}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-blue-50">
          <h2 className="text-base font-semibold text-blue-900 flex items-center gap-2">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="text-blue-400 hover:text-blue-700 transition rounded-lg p-1 hover:bg-blue-100"
          >
            <RiCloseLine className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 max-h-[80vh] overflow-y-auto bg-white">
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );

const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const InfoRow = ({ icon: Icon, label, value }) => (
  <div className="flex items-start gap-3 py-2 border-b border-blue-50 last:border-0">
    <div className="w-7 h-7 rounded-md bg-blue-50 border border-blue-100 flex items-center justify-center flex-shrink-0 mt-0.5">
      <Icon className="w-3.5 h-3.5 text-blue-500" />
    </div>
    <div className="min-w-0">
      <p className="text-[10px] font-semibold text-blue-400 uppercase tracking-widest">
        {label}
      </p>
      <p className="text-sm text-slate-700 font-medium truncate">
        {value || "—"}
      </p>
    </div>
  </div>
);

const ItemCard = ({ item }) => (
  <div className="bg-blue-50/40 border border-blue-100 rounded-xl p-4 mb-3 last:mb-0">
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 rounded-md bg-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm">
          {(item.media?.organisation || "?")[0].toUpperCase()}
        </div>
        <span className="text-sm font-semibold text-slate-800">
          {item.media?.organisation || "—"}
        </span>
      </div>
      <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-blue-100 text-blue-600">
        {item.hue || "—"}
      </span>
    </div>
    <div className="grid grid-cols-2 gap-x-6 gap-y-1.5 text-xs text-slate-500 mb-3">
      <div>
        <span className="text-blue-400 font-semibold">Publication:</span>{" "}
        {item.publication || "—"}
      </div>
      <div>
        <span className="text-blue-400 font-semibold">Edition:</span>{" "}
        {item.edition || "—"}
      </div>
      <div>
        <span className="text-blue-400 font-semibold">Ad Type:</span>{" "}
        {item.adType || "—"}
      </div>
      <div>
        <span className="text-blue-400 font-semibold">Page:</span>{" "}
        {item.pagePosition || "—"}
      </div>
      <div>
        <span className="text-blue-400 font-semibold">Size:</span> {item.width}{" "}
        × {item.height} cm
      </div>
      <div>
        <span className="text-blue-400 font-semibold">DOP:</span>{" "}
        {formatDate(item.dop)}
      </div>
      <div>
        <span className="text-blue-400 font-semibold">Rate/Sq Cm:</span> ₹
        {item.ratePerSqCm}
      </div>
      <div>
        <span className="text-blue-400 font-semibold">GST:</span> {item.gst}%
      </div>
      <div>
        <span className="text-blue-400 font-semibold">Agency Comm:</span>{" "}
        {item.agencyCommission}%
      </div>
      <div>
        <span className="text-blue-400 font-semibold">Other Disc:</span>{" "}
        {item.otherDiscount}%
      </div>
    </div>
    <div className="flex items-center justify-between pt-2 border-t border-blue-100">
      <div className="text-xs text-slate-400">
        Gross:{" "}
        <span className="font-semibold text-slate-600">
          ₹{item.totalGross?.toLocaleString("en-IN")}
        </span>
      </div>
      <div className="text-sm font-bold text-blue-700">
        Net: ₹
        {item.netPayableAmount?.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </div>
    </div>
  </div>
);

const InvoiceStatusBadge = ({ status }) => {
  const isPending = !status || status === "pending";
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider
        ${isPending ? "bg-amber-100 text-amber-700 border border-amber-200" : "bg-emerald-100 text-emerald-700 border border-emerald-200"}`}
    >
      {isPending ? (
        <RiTimeLine className="w-3 h-3" />
      ) : (
        <RiCheckboxCircleLine className="w-3 h-3" />
      )}
      {isPending ? "Pending" : "Complete"}
    </span>
  );
};

// ─── Confirm Delete Modal (direct delete, no OTP) ────────────────────────────
const ConfirmDeleteModal = ({ variant, onClose, onDeleted, notify }) => {
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    setDeleting(true);
    try {
      await axios.delete(`${BASE_URL}/delete/${variant._id}`);
      notify("Release order deleted successfully");
      onDeleted();
      onClose();
    } catch (err) {
      notify(
        err?.response?.data?.message || "Failed to delete release order",
        "error",
      );
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal
      title={
        <>
          <RiDeleteBinLine className="w-5 h-5 text-red-500" />
          Confirm Deletion
        </>
      }
      onClose={onClose}
      maxWidth="max-w-md"
    >
      <div className="text-center py-2">
        <div className="w-16 h-16 rounded-full bg-red-50 border-2 border-red-100 flex items-center justify-center mx-auto mb-4">
          <RiErrorWarningLine className="w-8 h-8 text-red-500" />
        </div>
        <p className="text-slate-700 font-semibold mb-1 text-base">
          Delete{" "}
          <span className="text-red-500 font-mono">{variant?.roNumber}</span>?
        </p>
        <p className="text-slate-400 text-sm mb-6">
          This action is <strong className="text-red-500">irreversible</strong>.
          All data for this release order will be permanently removed.
        </p>
        <div className="flex justify-center gap-3">
          <button
            onClick={onClose}
            className="flex items-center gap-1.5 px-5 py-2.5 rounded-xl text-sm text-slate-500 border border-slate-200 hover:bg-slate-50 transition font-semibold"
          >
            <RiCloseLine className="w-4 h-4" /> Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={deleting}
            className="flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold bg-red-500 hover:bg-red-600 text-white transition shadow-md shadow-red-100 disabled:opacity-60"
          >
            {deleting ? <Spinner /> : <RiDeleteBinLine className="w-4 h-4" />}
            {deleting ? "Deleting…" : "Confirm Delete"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
export default function AllRo() {
  const navigate = useNavigate();
  const [roGroups, setRoGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null);
  const [selected, setSelected] = useState(null);
  const [toast, setToast] = useState(null);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [previewGroup, setPreviewGroup] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // Only users whose stored admin data has userType === "admin" can delete
  const isAdmin = getAdminData()?.userType === "admin";

  const notify = (message, type = "success") => setToast({ message, type });

  const fetchROs = async (pageNo = page, searchText = search) => {
    setLoading(true);

    try {
      const res = await axios.get(
        `${BASE_URL}/all?page=${pageNo}&limit=10&search=${searchText}`,
      );

      setRoGroups(res.data?.data || []);
      setPage(res.data?.pagination?.currentPage || 1);
      setTotalPages(res.data?.pagination?.totalPages || 1);
    } catch {
      notify("Failed to fetch release orders", "error");
    } finally {
      setLoading(false);
    }
  };

  const handlePreviewGroup = (group) => {
    const clientName = group.client?.bankName || group.client?.name || "";
    const allItems = (group.variants || []).flatMap((v) =>
      (v.items || []).map((item) => ({
        ...item,
        roNumber: v.roNumber,
        rate: item.ratePerSqCm || item.rate || 0,
        width: parseFloat(item.width) || 0,
        height: parseFloat(item.height) || 0,
        agencyCommission: parseFloat(item.agencyCommission) || 0,
        otherDiscount: parseFloat(item.otherDiscount) || 0,
        cashDiscount: parseFloat(item.cashDiscount) || 0,
        gst: parseFloat(item.gst) || 0,
        publication: item.publication || item.media?.organisation || "",
        adType: item.adType || "",
        edition: item.edition || "",
        hue: item.hue || "B/W",
        dop: item.dop || "",
        pagePosition: item.pagePosition || "",
        totalGross: item.totalGross || item.grossAmount || 0,
        netPayableAmount: item.netPayableAmount || 0,
      })),
    );

    setPreviewGroup({
      roNumber: group.baseRONumber || "",
      date: group.date || "",
      caption: group.variants?.[0]?.caption || "",
      createdAt: group.createdAt || group.date || "",
      client: group.client,
      items: allItems,
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchROs(1, search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const openView = (variant) => {
    setSelected(variant);
    setModal("view");
  };

  const openDelete = (variant) => {
    if (!isAdmin) {
      notify("Only admin users can delete release orders", "error");
      return;
    }
    setSelected(variant);
    setModal("delete");
  };

  const openEdit = (variant) => {
    navigate(`/admin/edit-release-order/${variant._id}`);
  };
  const closeModal = () => {
    setModal(null);
    setSelected(null);
  };

  const handleDownloadPDF = async (variantId) => {
    try {
      const res = await axios.get(`${BASE_URL}/${variantId}`);
      const roData = res.data?.data || res.data;
      if (!roData) {
        notify("No data received from server", "error");
        return;
      }
      const normalizedRO = {
        roNumber: roData.roNumber || "",
        date: roData.date || "",
        caption: roData.caption || "",
        createdAt: roData.createdAt || "",
        client: {
          ...roData.client,
          bankName: roData.client?.bankName || roData.client?.name || "",
        },
        staff: roData.staff || undefined,
        agent: roData.agent || undefined,
        items: (roData.items || []).map((item) => ({
          ...item,
          roNumber: roData.roNumber || "",
          rate: item.ratePerSqCm || item.rate || 0,
          width: parseFloat(item.width) || 0,
          height: parseFloat(item.height) || 0,
          agencyCommission: parseFloat(item.agencyCommission) || 0,
          otherDiscount: parseFloat(item.otherDiscount) || 0,
          cashDiscount: parseFloat(item.cashDiscount) || 0,
          gst: parseFloat(item.gst) || 0,
          publication: item.publication || item.media?.organisation || "",
          adType: item.adType || "",
          edition: item.edition || "",
          hue: item.hue || "B/W",
          dop: item.dop || "",
          pagePosition: item.pagePosition || "",
          totalGross: item.totalGross || item.grossAmount || 0,
          netPayableAmount: item.netPayableAmount || 0,
        })),
      };
      if (normalizedRO.items.length === 0) {
        notify("No items found in this release order", "error");
        return;
      }
      generateReleaseOrderPDF(normalizedRO);
    } catch (err) {
      notify(err?.response?.data?.message || "Failed to download PDF", "error");
    }
  };

  const handleCreateInvoice = (baseRONumber) => {
    const parts = baseRONumber.split("/");
    if (parts.length === 3) {
      navigate(
        `/create-Invoice-by-releaseorder/${parts[0]}/${parts[1]}/${parts[2]}`,
      );
    } else {
      notify("Invalid RO number format", "error");
    }
  };

  const toggleExpand = (baseRONumber) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(baseRONumber)) newExpanded.delete(baseRONumber);
    else newExpanded.add(baseRONumber);
    setExpandedRows(newExpanded);
  };

  const filtered = roGroups;

  const tableHeaders = [
    { label: "Base RO Number", Icon: RiFileTextLine },
    { label: "Client", Icon: RiBuildingLine },
    { label: "Variants", Icon: RiLayoutColumnLine },
    { label: "Date", Icon: RiCalendarLine },
    { label: "Items Count", Icon: RiNewspaperLine },
    { label: "Total Net Payable", Icon: RiPriceTag3Line },
    { label: "Status" },
    { label: "Actions" },
  ];

  const getTotalNetForGroup = (variants = []) =>
    variants.reduce((sum, v) => {
      const variantTotal =
        v.items?.reduce((vsum, i) => vsum + (i.netPayableAmount || 0), 0) || 0;
      return sum + variantTotal;
    }, 0);

  const getTotalNetForVariant = (items = []) =>
    items.reduce((sum, i) => sum + (i.netPayableAmount || 0), 0);

  const pendingCount = roGroups.filter((g) =>
    g.variants?.every((v) => !v.invoiceStatus || v.invoiceStatus === "pending"),
  ).length;

  const completeCount = roGroups.filter((g) =>
    g.variants?.every((v) => v.invoiceStatus && v.invoiceStatus !== "pending"),
  ).length;

  return (
    <div className="min-h-screen bg-white text-slate-800">
      <header className="bg-white border-b border-blue-100 sticky top-0 z-30 shadow-sm">
        <div className="w-full mx-auto px-6 py-3.5 flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-blue-600 flex items-center justify-center text-white shadow-md shadow-blue-200">
              <RiFileTextLine className="w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-bold text-blue-800 tracking-tight">
                Release Orders
              </h1>
              <p className="text-[11px] text-blue-400 tracking-widest uppercase">
                RO Management
              </p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="relative">
              <RiSearchLine className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-blue-400" />
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search ROs…"
                className="bg-blue-50 border border-blue-200 rounded-lg pl-9 pr-3 py-2 text-sm text-slate-700 placeholder-blue-300 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 w-52 transition"
              />
            </div>
            <button
              onClick={() => fetchROs(page)}
              disabled={loading}
              title="Refresh"
              className="w-9 h-9 flex items-center justify-center rounded-lg border border-blue-200 text-blue-400 hover:text-blue-600 hover:bg-blue-50 transition disabled:opacity-50"
            >
              <RiRefreshLine
                className={`w-4 h-4 ${loading ? "animate-spin" : ""}`}
              />
            </button>
          </div>
        </div>
      </header>

      <div className="w-full mx-auto px-6 pt-6 pb-10">
        {/* Stats row */}
        <div className="flex items-center gap-3 mb-5 flex-wrap">
          {[
            {
              key: "all",
              label: "All Orders",
              count: roGroups.length,
              activeClass:
                "bg-blue-600 text-white border-blue-600 shadow-md shadow-blue-200",
              countClass: "bg-white/20 text-white",
              inactiveClass:
                "bg-white text-slate-500 border-blue-100 hover:border-blue-300",
              inactiveCountClass: "bg-blue-100 text-blue-600",
            },
            {
              key: "pending",
              label: "Pending Invoice",
              count: pendingCount,
              Icon: RiTimeLine,
              activeClass:
                "bg-amber-500 text-white border-amber-500 shadow-md shadow-amber-200",
              countClass: "bg-white/20 text-white",
              inactiveClass:
                "bg-white text-slate-500 border-blue-100 hover:border-amber-300",
              inactiveCountClass: "bg-amber-100 text-amber-700",
            },
            {
              key: "complete",
              label: "Invoice Complete",
              count: completeCount,
              Icon: RiCheckboxCircleLine,
              activeClass:
                "bg-emerald-600 text-white border-emerald-600 shadow-md shadow-emerald-200",
              countClass: "bg-white/20 text-white",
              inactiveClass:
                "bg-white text-slate-500 border-blue-100 hover:border-emerald-300",
              inactiveCountClass: "bg-emerald-100 text-emerald-700",
            },
          ].map(
            ({
              key,
              label,
              count,
              Icon,
              activeClass,
              countClass,
              inactiveClass,
              inactiveCountClass,
            }) => (
              <button
                key={key}
                onClick={() => setStatusFilter(key)}
                className={`flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold border transition
                ${statusFilter === key ? activeClass : inactiveClass}`}
              >
                {Icon && <Icon className="w-3.5 h-3.5" />}
                {label}
                <span
                  className={`px-1.5 py-0.5 rounded-full text-[10px] font-bold ${statusFilter === key ? countClass : inactiveCountClass}`}
                >
                  {count}
                </span>
              </button>
            ),
          )}
        </div>

        {/* Table */}
        <div className="bg-white border border-blue-100 rounded-2xl overflow-hidden shadow-sm">
          <div className="px-5 py-3.5 border-b border-blue-50 bg-blue-50/50 flex items-center justify-between">
            <span className="text-sm font-semibold text-blue-800 flex items-center gap-2">
              <RiFileTextLine className="w-4 h-4 text-blue-500" />
              {statusFilter === "all"
                ? "All Release Orders"
                : statusFilter === "pending"
                  ? "Pending Invoice ROs"
                  : "Invoice Complete ROs"}
            </span>
            <span className="text-xs text-blue-400">
              {filtered.length} group{filtered.length !== 1 ? "s" : ""}
            </span>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-blue-100 bg-blue-50/30">
                  {tableHeaders.map(({ label, Icon }) => (
                    <th key={label} className="px-4 py-3 text-left">
                      <span className="flex items-center gap-1.5 text-xs font-semibold text-blue-500 uppercase tracking-widest whitespace-nowrap">
                        {Icon && <Icon className="w-3.5 h-3.5" />}
                        {label}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={8} className="py-20 text-center">
                      <div className="flex flex-col items-center gap-3 text-blue-400">
                        <AiOutlineLoading3Quarters className="w-7 h-7 animate-spin text-blue-500" />
                        <span className="text-sm">Loading release orders…</span>
                      </div>
                    </td>
                  </tr>
                ) : filtered.length === 0 ? (
                  <tr>
                    <td colSpan={8} className="py-20 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-14 h-14 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center">
                          <RiFileTextLine className="w-7 h-7 text-blue-300" />
                        </div>
                        <span className="text-sm text-slate-400">
                          {search
                            ? "No release orders match your search."
                            : "No release orders found."}
                        </span>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filtered.map((group, groupIdx) => {
                    const isExpanded = expandedRows.has(group.baseRONumber);
                    const groupTotal = getTotalNetForGroup(group.variants);
                    const allPending = group.variants?.every(
                      (v) => !v.invoiceStatus || v.invoiceStatus === "pending",
                    );

                    return (
                      <React.Fragment key={group.baseRONumber || groupIdx}>
                        <tr
                          className={`border-b border-blue-50 transition group ${allPending ? "hover:bg-amber-50/40 cursor-pointer" : "hover:bg-blue-50/50"}`}
                        >
                          <td className="px-4 py-3 font-semibold text-slate-800 whitespace-nowrap">
                            <div className="flex items-center gap-2.5">
                              <button
                                onClick={() => toggleExpand(group.baseRONumber)}
                                className="flex-shrink-0 text-blue-500 hover:text-blue-700 transition"
                              >
                                {isExpanded ? (
                                  <RiArrowUpLine className="w-4 h-4" />
                                ) : (
                                  <RiArrowDownSLine className="w-4 h-4" />
                                )}
                              </button>
                              <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center text-white text-xs font-bold shadow-sm shadow-blue-200 flex-shrink-0">
                                <RiFileTextLine className="w-4 h-4" />
                              </div>
                              <span className="text-blue-700 font-mono text-xs font-bold">
                                {group.baseRONumber || "—"}
                              </span>
                            </div>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <div className="flex items-center gap-2">
                              {group.client?.bankLogo ? (
                                <img
                                  src={group.client.bankLogo}
                                  alt=""
                                  className="w-6 h-6 rounded object-contain border border-blue-100 bg-white"
                                />
                              ) : (
                                <div className="w-6 h-6 rounded bg-blue-100 flex items-center justify-center">
                                  <RiBuildingLine className="w-3.5 h-3.5 text-blue-400" />
                                </div>
                              )}
                              <span className="text-slate-700 text-sm font-medium">
                                {group.client?.bankName || "—"}
                              </span>
                            </div>
                          </td>
                          <td className="px-4 py-3">
                            <span className="inline-flex items-center gap-1 text-xs font-semibold px-2.5 py-1 rounded-full bg-blue-100 text-blue-600">
                              {group.variants?.length || 0} variant
                              {(group.variants?.length || 0) !== 1 ? "s" : ""}
                            </span>
                          </td>
                          <td className="px-4 py-3 text-slate-500 whitespace-nowrap">
                            {formatDate(group.date)}
                          </td>
                          <td className="px-4 py-3">
                            <span className="text-xs font-semibold text-slate-600">
                              {group.variants?.reduce(
                                (sum, v) => sum + (v.items?.length || 0),
                                0,
                              ) || 0}{" "}
                              items
                            </span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className="text-sm font-bold text-blue-700">
                              ₹
                              {groupTotal.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </span>
                          </td>
                          <td className="px-4 py-3">
                            <InvoiceStatusBadge
                              status={allPending ? "pending" : "complete"}
                            />
                          </td>
                          <td className="px-4 py-3">
                            <div className="flex gap-2 flex-wrap">
                              <button
                                onClick={() => toggleExpand(group.baseRONumber)}
                                className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                              >
                                <RiEyeLine className="w-3.5 h-3.5" />
                                {isExpanded ? "Hide" : "View"} Variants
                              </button>
                              <button
                                onClick={() => handlePreviewGroup(group)}
                                className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-violet-50 border border-violet-200 text-violet-600 hover:bg-violet-100 font-semibold transition"
                              >
                                <RiEyeLine className="w-3.5 h-3.5" /> Preview RO
                              </button>
                              {allPending && (
                                <button
                                  onClick={() =>
                                    handleCreateInvoice(group.baseRONumber)
                                  }
                                  className="flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-indigo-600 border border-indigo-600 text-white hover:bg-indigo-700 font-semibold transition shadow-sm shadow-indigo-200"
                                >
                                  <RiAddLine className="w-3.5 h-3.5" /> Invoice
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>

                        {isExpanded && (
                          <tr className="border-b border-indigo-200 bg-indigo-100/60">
                            <td className="px-4 py-2 pl-12">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                RO Number
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                Media
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                Edition
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                Hue
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                Size (cm)
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                Rate/sq cm
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                DOP
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              <span className="text-[10px] font-bold text-indigo-400 uppercase tracking-widest">
                                Net Amount / Actions
                              </span>
                            </td>
                          </tr>
                        )}

                        {isExpanded &&
                          group.variants &&
                          group.variants.flatMap((variant, varIdx) =>
                            (variant.items?.length > 0
                              ? variant.items
                              : [null]
                            ).map((item, iIdx) => {
                              const variantTotal = getTotalNetForVariant(
                                variant.items,
                              );
                              const isFirstItem = iIdx === 0;
                              const isLastItem =
                                iIdx === (variant.items?.length || 1) - 1;

                              return (
                                <tr
                                  key={`${variant._id || varIdx}-${iIdx}`}
                                  className={`border-b border-indigo-50 transition
            ${iIdx % 2 === 0 ? "bg-indigo-50/20" : "bg-white"}
            ${isLastItem ? "border-b-2 border-indigo-100" : ""}
          `}
                                >
                                  {/* RO Number — only on first item row */}
                                  <td
                                    className="px-4 py-2.5 whitespace-nowrap pl-12"
                                    rowSpan={
                                      isFirstItem
                                        ? variant.items?.length || 1
                                        : undefined
                                    }
                                    style={
                                      !isFirstItem ? { display: "none" } : {}
                                    }
                                  >
                                    {isFirstItem && (
                                      <div className="flex items-center gap-2">
                                        <div className="w-7 h-7 rounded-lg bg-indigo-600 flex items-center justify-center text-white text-xs font-bold shadow-sm flex-shrink-0">
                                          {variant.roNumber
                                            ?.split("(")[1]
                                            ?.charAt(0) || "V"}
                                        </div>
                                        <span className="text-indigo-700 font-mono text-xs font-bold whitespace-nowrap">
                                          {variant.roNumber || "—"}
                                        </span>
                                      </div>
                                    )}
                                  </td>

                                  {/* Media */}
                                  <td className="px-4 py-2.5">
                                    {item ? (
                                      <div className="flex items-center gap-2">
                                        <div className="w-5 h-5 rounded bg-indigo-600 flex items-center justify-center text-white text-[10px] font-bold flex-shrink-0">
                                          {(item.media?.organisation ||
                                            item.publication ||
                                            "?")[0].toUpperCase()}
                                        </div>
                                        <span className="text-xs font-semibold text-slate-700 whitespace-nowrap">
                                          {item.media?.organisation ||
                                            item.publication ||
                                            "—"}
                                        </span>
                                      </div>
                                    ) : (
                                      <span className="text-slate-300 text-xs">
                                        —
                                      </span>
                                    )}
                                  </td>

                                  {/* Edition */}
                                  <td className="px-4 py-2.5 text-xs text-slate-600 whitespace-nowrap">
                                    {item?.edition || "—"}
                                  </td>

                                  {/* Hue */}
                                  <td className="px-4 py-2.5">
                                    {item && (
                                      <span
                                        className={`inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold
                ${
                  item.hue === "Color"
                    ? "bg-violet-100 text-violet-600 border border-violet-200"
                    : "bg-slate-100 text-slate-500 border border-slate-200"
                }`}
                                      >
                                        {item.hue || "B/W"}
                                      </span>
                                    )}
                                  </td>

                                  {/* Size */}
                                  <td className="px-4 py-2.5 text-xs text-slate-600 font-mono whitespace-nowrap">
                                    {item
                                      ? `${item.width} × ${item.height}`
                                      : "—"}
                                  </td>

                                  {/* Rate/sq cm */}
                                  <td className="px-4 py-2.5 text-xs text-slate-600 whitespace-nowrap">
                                    {item
                                      ? `₹${(item.ratePerSqCm || item.rate || 0).toLocaleString("en-IN")}`
                                      : "—"}
                                  </td>

                                  {/* DOP */}
                                  <td className="px-4 py-2.5 text-xs text-slate-500 whitespace-nowrap">
                                    {item ? formatDate(item.dop) : "—"}
                                  </td>

                                  {/* Net Amount + Actions on first item only */}
                                  <td className="px-4 py-2.5 whitespace-nowrap">
                                    {item ? (
                                      <div className="flex items-center justify-between gap-4">
                                        <span className="text-xs font-bold text-indigo-700">
                                          ₹
                                          {(
                                            item.netPayableAmount || 0
                                          ).toLocaleString("en-IN", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })}
                                        </span>
                                        {isFirstItem && (
                                          <div className="flex gap-1.5 flex-wrap">
                                            <button
                                              onClick={() => openView(variant)}
                                              className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                                            >
                                              <RiEyeLine className="w-3 h-3" />{" "}
                                              View
                                            </button>
                                            <button
                                              onClick={() =>
                                                handleDownloadPDF(variant._id)
                                              }
                                              className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-600 hover:bg-emerald-100 font-semibold transition"
                                            >
                                              <RiDownloadLine className="w-3 h-3" />{" "}
                                              PDF
                                            </button>
                                            <button
                                              onClick={() => openEdit(variant)}
                                              className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-amber-50 border border-amber-200 text-amber-600 hover:bg-amber-100 font-semibold transition"
                                            >
                                              <RiEditLine className="w-3 h-3" />{" "}
                                              Edit
                                            </button>
                                            {isAdmin && (
                                              <button
                                                onClick={() =>
                                                  openDelete(variant)
                                                }
                                                className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
                                              >
                                                <RiDeleteBinLine className="w-3 h-3" />{" "}
                                                Delete
                                              </button>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      isFirstItem && (
                                        <div className="flex gap-1.5">
                                          <button
                                            onClick={() => openView(variant)}
                                            className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-blue-50 border border-blue-200 text-blue-600 hover:bg-blue-100 font-semibold transition"
                                          >
                                            <RiEyeLine className="w-3 h-3" />{" "}
                                            View
                                          </button>
                                          {isAdmin && (
                                            <button
                                              onClick={() =>
                                                openDelete(variant)
                                              }
                                              className="flex items-center gap-1 text-[11px] px-2.5 py-1 rounded-lg bg-red-50 border border-red-200 text-red-500 hover:bg-red-100 font-semibold transition"
                                            >
                                              <RiDeleteBinLine className="w-3 h-3" />{" "}
                                              Delete
                                            </button>
                                          )}
                                        </div>
                                      )
                                    )}
                                  </td>
                                </tr>
                              );
                            }),
                          )}
                      </React.Fragment>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-end gap-2 mt-4">
        <button
          disabled={page === 1}
          onClick={() => fetchROs(page - 1)}
          className="px-4 py-2 text-sm rounded-lg border border-blue-200 bg-white text-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Previous
        </button>

        <span className="px-3 text-sm font-medium text-slate-600">
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => fetchROs(page + 1)}
          className="px-4 py-2 text-sm rounded-lg border border-blue-200 bg-white text-blue-600 hover:bg-blue-50 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Next
        </button>
      </div>

      {/* View Modal */}
      {modal === "view" && selected && (
        <Modal
          title={
            <>
              <RiFileTextLine className="w-5 h-5 text-blue-500" />
              {selected.roNumber}
            </>
          }
          onClose={closeModal}
        >
          <div className="grid grid-cols-2 gap-4 mb-5">
            <div className="col-span-2 bg-blue-50 border border-blue-100 rounded-xl p-4">
              <p className="text-[10px] font-semibold text-blue-400 uppercase tracking-widest mb-1">
                Caption
              </p>
              <p className="text-base font-semibold text-slate-800">
                {selected.caption || "—"}
              </p>
            </div>
            <InfoRow
              icon={RiBuildingLine}
              label="Client"
              value={selected.client?.bankName}
            />
            <InfoRow
              icon={RiCalendarLine}
              label="RO Date"
              value={formatDate(selected.date)}
            />
            <InfoRow
              icon={RiUserLine}
              label="Agent"
              value={selected.agent?.name}
            />
            <InfoRow
              icon={RiPhoneLine}
              label="Agent Phone"
              value={selected.agent?.number}
            />
            <InfoRow
              icon={RiMailLine}
              label="Agent Email"
              value={selected.agent?.email}
            />
            <InfoRow
              icon={RiPercentLine}
              label="Client Head Office"
              value={selected.client?.headOffice}
            />
            <div className="mt-4 pt-4 border-t border-blue-100 flex gap-3">
              <button
                onClick={() => handleDownloadPDF(selected._id)}
                className="flex-1 flex items-center justify-center gap-2 py-2.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-bold transition shadow-md shadow-emerald-200"
              >
                <RiDownloadLine className="w-4 h-4" /> Download PDF
              </button>
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold text-blue-700 uppercase tracking-widest mb-3 flex items-center gap-2">
              <RiLayoutColumnLine className="w-4 h-4" />
              Ad Items ({selected.items?.length || 0})
            </p>
            {selected.items?.length > 0 ? (
              selected.items.map((item, idx) => (
                <ItemCard key={item._id || idx} item={item} />
              ))
            ) : (
              <p className="text-sm text-slate-400 text-center py-4">
                No items found.
              </p>
            )}
          </div>
          <div className="mt-4 pt-4 border-t border-blue-100 flex items-center justify-between">
            <span className="text-sm text-slate-500 font-medium">
              Total Net Payable
            </span>
            <span className="text-lg font-bold text-blue-700">
              ₹
              {getTotalNetForVariant(selected.items).toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
        </Modal>
      )}

      {/* Confirm Delete Modal (direct delete, admin only) */}
      {modal === "delete" && selected && isAdmin && (
        <ConfirmDeleteModal
          variant={selected}
          onClose={closeModal}
          onDeleted={() => fetchROs(page)}
          notify={notify}
        />
      )}
      {previewGroup && (
        <ROPreviewModal
          roData={previewGroup}
          roImageBase64={RO_IMAGE_BASE64}
          onClose={() => setPreviewGroup(null)}
        />
      )}

      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
}
